import { useCallback } from "react";
import { useStore } from "@/stores/useStore";
import { Task } from "@/types/v2";
import {
  tasksByAssignee as selectTasksByAssignee,
  tasksForCard as selectTasksForCard,
  taskCounts as selectTaskCounts,
} from "@/lib/taskSelectors";

export function useTasks() {
  const {
    tasks,
    openTaskCount,
    createTask,
    updateTask,
    completeTask,
    deleteTask,
  } = useStore();

  const tasksByAssignee = useCallback(
    (assigneeId: string) => selectTasksByAssignee(tasks, assigneeId),
    [tasks]
  );

  const tasksForCard = useCallback(
    (cardId: string) => selectTasksForCard(tasks, cardId),
    [tasks]
  );

  const taskCounts = useCallback((list: Task[]) => selectTaskCounts(list), []);

  return {
    tasks,
    openTaskCount,
    tasksByAssignee,
    tasksForCard,
    taskCounts,
    createTask,
    updateTask,
    completeTask,
    deleteTask,
  };
}
